import React, { useRef, useState } from 'react';
import StatusBar from '@dataGrid/components/StatusBar';
import DataGrid from '@dataGrid';
import GridHeader from './GridHeader';
import GridConfig from './GridConfig';
import { driverCommentsConstants, DriverComment } from './constants';

type DriverCommentsDataGridProps = {
  classes: Record<string, string>;
  driverComments: DriverComment[];
};

const constructStatusBar = (driverComments: DriverComment[]) => [
  {
    label: `${driverComments.length} ${driverCommentsConstants.LABEL.COMMENT_COUNT}`
  }
];

const DriverCommentsDataGrid = ({ classes, driverComments }: DriverCommentsDataGridProps) => {
  const [quickFilterText, setQuickFilterText] = useState('');
  const gridApi = useRef(null);
  const gridConfig = useRef(new GridConfig());

  const onGridReady = ({ api }) => {
    gridApi.current = api;
  };

  return (
    <div className={classes.moduleContainer}>
      <div className={`${classes.gridContainer} ${classes.driverCommentsGridContainer}`}>
        <GridHeader
          classes={classes}
          gridApi={gridApi.current}
          updateQuickFilterText={setQuickFilterText}
        />
        <div className={`${classes.dataGrid} ${classes.driverCommentsGrid}`}>
          <DataGrid
            defaultColDef={gridConfig.current.config.defaultColDef}
            columnDefs={gridConfig.current.config.columns}
            config={gridConfig.current.config}
            rowData={driverComments}
            getRowId={(params) => params.data.rowId}
            onGridReady={onGridReady}
            quickFilterText={quickFilterText}
            panelLabel={(filteredData) => (
              <StatusBar
                data={constructStatusBar(filteredData)}
                customClass={classes.statusBar}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default DriverCommentsDataGrid;
